import { render, staticRenderFns } from "./FinishFormAluminum.vue?vue&type=template&id=03cbc4ec&"
import script from "./FinishFormAluminum.vue?vue&type=script&lang=js&"
export * from "./FinishFormAluminum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports